import { post } from "axios"
import store from '../../../store'
// 获取所有店铺推荐商品
const getAllShopGoods = async ()=>{
    return await post("index.php?act=web_index&op=shopGoods",{
        page:8
    })
}
// 需求详情去联系
const connectionDema = async (dem_id)=>{
    return await post("index.php?act=store_demand&op=demand_ov",{
        dem_id
    })
}

const getHomeBanner = async (data)=>{
    return await post("index.php?act=web_index&op=getBannerList",{
        ...data
    })
}
// 推荐列表
const getlistRecom = async (data)=>{
     let res = await post("index.php?act=store_shop&op=listRecom",{
        ...data
    })
   
    if(store.state.exBrands&&res&&res.length>0){
		res = res.filter(item=>!store.state.exBrands.includes(item.oenaturebrand))
	}
    return res
}
// 折扣列表
const getDisList = async (data)=>{
    let house = ""
    if(store.state.shop==1780){
        house = store.state.is_sh=="0"?'丹阳仓':"上海仓"
    }
     let res = await post("index.php?act=groupbuy&op=get_discount",{
        ...data,
        house
    })
    
    if(store.state.exBrands&&res.db&&res.db.length>0){
		res.db = res.db.filter(item=>!store.state.exBrands.includes(item.oenaturebrand))
	}
    return res
}
const getOtherDisList = async (data)=>{
    let house = ""
    if(store.state.shop==1780){
        house = store.state.is_sh=="0"?'丹阳仓':"上海仓"
    }
    // house
     let res = await post("index.php?act=groupbuy&op=get_discount_other",{
        ...data,
    })
    
    // if(store.state.exBrands&&res.db&&res.db.length>0){
	// 	res.db = res.db.filter(item=>!store.state.exBrands.includes(item.oenaturebrand))
	// }
    return res
}
// 获取折扣分类

const getMdisClass = async (data)=>{
     let res = await post("index.php?act=groupbuy&op=promotion",{
        ...data
    })
    return res
}
// 获取推荐图片
const getlistRecomImg = async (data)=>{
     let res = await post("index.php?act=goods&op=goods_default",{
        ...data
    })
    return res
}
// 获取热门商品分类
const getHotGoodsClass = async (data)=>{
     let res = await post("index.php?act=store_shop&op=category",{
        
    })
    return res
}
// 秒杀列表
const getSeckiList = async (data)=>{
    let res = await post("index.php?act=groupbuy&op=getlist",{
        ...data
    })
    
    if(store.state.exBrands&&res&&res.length>0){
		res = res.filter(item=>!store.state.exBrands.includes(item.oenaturebrand))
	}
    return res
}
// 采购报表
const getReport = async (data)=>{
    let res = await post("index.php?act=favorites&op=report",{
        ...data
    })
    return res
}
// 添加别名

const addAlias = async (data)=>{
    let res = await post("index.php?act=web_index&op=alias_goods",{
        ...data
    })
    return res
}
// 获取产品中心
const getBrandTalk = async (parent_id)=>{
    let res = await post("index.php?act=brands_talk&op=getTalk",{
        parent_id,
        page: 1,
        limit: 999
    })
    return res
}
// 获取产品中心配件
const getBrandTalkParts = async (ids)=>{
    let res = await post("index.php?act=brands_talk&op=getPartsByIds",{
        ids,
        page: 1,
        limit: 999,
        buyer_id:store.state.buyer_id
    })
    return res
}

// 到货提醒
const getStockInform = async ()=>{
    
    let res = await post("index.php?act=store_cart&op=stock_inform",{
        shop_id:store.state.shop,
        member_id: store.state.member_id,
        is_sh:store.state.is_sh
    })
    return res
}
// 获取配件海报
const getPosterImgByIds = async (data)=>{
    let res = await post("index.php?act=web_index&op=poster",{
        ...data
    })
    return res
}
// 申请创建海报 
const createPoster = async (data)=>{
    console.log("data",data);
    
    let res = await post("index.php?act=poster&op=createPoster",{
        ...data
    })
    return res
}
// 获取海报库
const getSystemPoster = async (data)=>{
    let res = await post("index.php?act=poster&op=getSystemPoster",{
        ...data
    })
    return res
}
const getUserPoster = async (data)=>{
    let res = await post("index.php?act=poster&op=getUserPoster",{
        ...data
    })
    return res
}
const delUserPoster = async (ids)=>{
    let res = await post("index.php?act=poster&op=removeByIds",{
        ids
    })
    return res
}
// 获取我的海报 
export {
    getPosterImgByIds,
    getAllShopGoods,
    connectionDema,
    getHomeBanner,
    getlistRecom,
    getDisList,
    getOtherDisList,
    getMdisClass,
    getlistRecomImg,
    getHotGoodsClass,
    getSeckiList,
    getReport,
    addAlias,
    getBrandTalk,
    getBrandTalkParts,
    getStockInform,
    createPoster,
    getSystemPoster,
    getUserPoster,
    delUserPoster
}